var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 10V11H18V10C18 9.44772 18.4477 9 19 9C19.5523 9 20 9.44772 20 10V18C20 20.2091 18.2091 22 16 22H4C1.79086 22 0 20.2091 0 18V10C0 9.44772 0.447715 9 1 9C1.55228 9 2 9.44772 2 10ZM2 11V18C2 19.1046 2.89543 20 4 20H16C17.1046 20 18 19.1046 18 18V11H2ZM10 0C10.2978 0 10.5652 0.130167 10.7484 0.336707L13.7066 3.2924C14.0974 3.68265 14.0979 4.31582 13.7076 4.70661C13.3173 5.09741 12.6842 5.09785 12.2934 4.7076L11 3.416V13C11 13.5523 10.5523 14 10 14C9.44772 14 9 13.5523 9 13V3.415L7.70661 4.7076C7.34588 5.06783 6.77863 5.09517 6.38655 4.78987L6.2924 4.70661C5.90215 4.31582 5.90259 3.68265 6.29339 3.2924L9.25163 0.336707C9.43482 0.130167 9.70221 0 10 0Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareBlack);
export default __webpack_public_path__ + "static/media/share-black.ae09a681.svg";
export { ForwardRef as ReactComponent };